import constants from '../../constants';
import './index_mWeb.css';

const MatchMakingPlayerFoundMWeb = () => {
  return (
    <div className="matchMakingPlayerFound__container__mWeb">
      <div className={'matchMakingPlayerFound__imgContainer__mWeb'}>
        <img className={'matchMakingPlayerFound__img__mWeb'} src={constants.Images.swords} />
        <span className="matchMakingPlayerFound__statusText__mWeb" style={{ paddingTop: '25px' }}>
          Player Found
        </span>
      </div>
      <div className={'matchMakingPlayerFound__gameProgressText__mWeb'}>Game Starts</div>
    </div>
  );
};

export default MatchMakingPlayerFoundMWeb;
